import React, { useEffect, useState } from "react";
import { Autocomplete, Button, Table, TableBody, TableCell, TableRow, TextField } from "@mui/material";
import Logo from "../../image/compnay_logo.png";
import Text from "../../../utils/commonComponent/Custom/text";
import { fetchDatasheetDetails } from "../fetchHandler";
import { useParams } from "react-router-dom";
import { DateisValid } from "../../../utils/commonComponent/errorAlert";
import { parseDepth } from "../../../utils/commonComponent/parse";
import { DisciplineOptions } from "../../disciplineMaster/disiplineConst";
import { AddButton } from "../../../utils/commonComponent/Custom/Button";
import { getPermissions } from "../../rbac/hasAccess";
import LoaderModal from "../../../utils/loader.js/loader";
import { generateDatasheetPDF } from "./datasheetPrint";
import { observationSheetApprove } from "../submitHandler";
import RenderStaticTables from "./viewRenderTables";
import { fetchObservationSheetPdf } from "./fetchObservationSheetPdf";

const HeaderRowDetailsTable = ({ datasheetDetails }) => {
  const cellStyle = {
    border: "1px solid #000",
    padding: "4px 8px",
    textAlign: "center",
  };
  const rowSpanCellStyle = {
    ...cellStyle,
    verticalAlign: "middle",
  };
  return (
    <div className="overflow-auto max-w-full">
      {/* Header Table */}
      <Table style={{ borderCollapse: "collapse", width: "100%" }}>
        <TableBody>
          <TableRow>
            <TableCell rowSpan={4} style={rowSpanCellStyle}>
              <img src={Logo} alt="Logo" className="h-16" />
            </TableCell>

            {/* Title Cell */}
            <TableCell rowSpan={4} style={rowSpanCellStyle}>
              <b>
                LABCITY CALIBRATION SERVICES <br />
                Observation Sheet -{" "}
                {datasheetDetails?.materialTestings_testName || ""}
              </b>
            </TableCell>

            {/* Header Cells */}
            <TableCell style={cellStyle}>
              <b>Document Number</b>
            </TableCell>
            <TableCell style={cellStyle}>-</TableCell>
          </TableRow>

          <TableRow>
            <TableCell style={cellStyle}>
              <b>Issue No. / Date</b>
            </TableCell>
            <TableCell style={cellStyle}>- /</TableCell>
          </TableRow>
        </TableBody>
      </Table>


      <Text align="center" variant="h2" bold className="my-6">
        ObservationSheet of {datasheetDetails?.materialTestings_testName}
      </Text>

      {/* Purpose / Calibration Info Table */}
      <Table style={{ borderCollapse: "collapse", width: "100%" }}>
        <TableBody>
          <TableRow>
            <TableCell style={cellStyle}>
              <b>Job No.</b>
            </TableCell>
            <TableCell style={cellStyle}>
              <b>{datasheetDetails?.jobRegister_jobNumber || ""}</b>
            </TableCell>
            <TableCell style={cellStyle}>
              <b>Lab Reference No.</b>
            </TableCell>
            <TableCell style={cellStyle}>
              <b>{datasheetDetails?.inward_labReferenceNo}</b>
            </TableCell>
            <TableCell style={cellStyle}>
              <b>Testing No.</b>
            </TableCell>
            <TableCell style={cellStyle}>
              {datasheetDetails?.observationSheet_testNumber || ""}
            </TableCell>
          </TableRow>          
          <TableRow>
            <TableCell style={cellStyle}>
              <b>Start Date Testing</b>
            </TableCell>
            <TableCell style={cellStyle} colSpan={2}>
              <b>{DateisValid(datasheetDetails?.observationSheet_startTestingDate) || ""}</b>
            </TableCell>
            <TableCell style={cellStyle}>
              <b>End Date Testing</b>
            </TableCell>
            <TableCell style={cellStyle} colSpan={2}>
              <b>{DateisValid(datasheetDetails?.observationSheet_endTestingDate)}</b>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

const TestDetailsTable = ({ datasheetDetails }) => {
  const details = [
    { label: "Group", value: datasheetDetails?.discipline_groupName },
    { label: "Material", value: datasheetDetails?.materialScope_MaterialName },
    { label: "BH No./Trial Pit No.", value: datasheetDetails?.observationSheet_boreHoleNo },
    { label: "Location/Chainage No./Source.", value: datasheetDetails?.inwardTests_locationChainageNo },
    { label: "From Depth", value: parseDepth(datasheetDetails?.inwardTests_fromDepth) },
    { label: "To Depth", value: parseDepth(datasheetDetails?.inwardTests_toDepth) },
    { label: "Sample Type", value: datasheetDetails?.inwardTests_sampleType },
    { label: "Quantity", value: datasheetDetails?.inwardTests_quantity },
    { label: "Length Of Rock", value: parseDepth(datasheetDetails?.inwardTests_lengthOfRock) },
  ];

  const cellStyle = {
    border: "1px solid #000",
    padding: "4px 8px",
    textAlign: "left",
    width: "25%", // each cell takes 25%
  };

  // Split details into chunks of 2 for each row
  const rows = [];
  for (let i = 0; i < details.length; i += 2) {
    rows.push(details.slice(i, i + 2));
  }

  return (
    <div className="overflow-auto max-w-full mt-4">
      <Table style={{ borderCollapse: "collapse", width: "100%" }}>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {row.map((item, cellIndex) => (
                <React.Fragment key={cellIndex}>
                  <TableCell style={cellStyle}>
                    <b>{item.label}</b>
                  </TableCell>
                  <TableCell style={cellStyle}>{item.value || ""}</TableCell>
                </React.Fragment>
              ))}
              {/* Fill empty cells if row has only one pair */}
              {row.length < 2 && (
                <>
                  <TableCell style={cellStyle}></TableCell>
                  <TableCell style={cellStyle}></TableCell>
                </>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

const DatasheetFooter = ({ datasheetDetails }) => {
  const cellStyle = {
    border: "1px solid #000",
    padding: "4px 6px",
    fontSize: "13px",
    verticalAlign: "top",
    textAlign: "left",
  };

  const imgStyle = {
    display: "block",
    marginTop: "4px",
    height: "40px",
    width: "auto",
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Table style={{ borderCollapse: "collapse", width: "100%" }}>
        <TableBody>
          {/* Signature Rows */}
          <TableRow>
            <TableCell style={cellStyle}>
              <div style={{display:"flex", gap:"10px", alignItems:"center"}}>
              <b>Signature :</b>
              {datasheetDetails?.testedBy_userSign && (
                <img
                  alt="testedBy_userSign"
                  src={datasheetDetails.testedBy_userSign}
                  style={imgStyle}
                />
              )}
              </div>
            </TableCell>

            <TableCell style={cellStyle}>
              <div style={{display:"flex", gap:"10px", alignItems:"center"}}>
              <b>Signature :</b>
              {datasheetDetails?.approvedBy_userSign && (
                <img
                  alt="approvedBy_userSign"
                  src={datasheetDetails.approvedBy_userSign}
                  style={imgStyle}
                />
              )}
              </div>
            </TableCell>
          </TableRow>

          {/* Name Rows */}
          <TableRow>
            <TableCell style={cellStyle}>
              <b>Name :</b> {datasheetDetails?.testedBy_userName || ""}
            </TableCell>
            <TableCell style={cellStyle}>
              <b>Name :</b> {datasheetDetails?.approvedBy_userName || ""}
            </TableCell>
          </TableRow>

          {/* Designation Rows */}
          <TableRow>
            <TableCell style={cellStyle}>
              <b>Designation :</b>{" "}
              {datasheetDetails?.testedBy_hrDesignation || ""}
            </TableCell>
            <TableCell style={cellStyle}>
              <b>Designation :</b>{" "}
              {datasheetDetails?.approvedBy_hrDesignation || ""}
            </TableCell>
          </TableRow>

          {/* Tested / Approved Rows */}
          <TableRow>
            <TableCell style={cellStyle}>
              <b>Tested By :</b>
            </TableCell>
            <TableCell style={cellStyle}>
              <b>Approved By :</b>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

// Single Datasheet Component
const SingleDatasheet = ({ datasheetDetails, showApproveButton, rolesInfo, params }) => {
  return (
    <div style={{ marginBottom: "40px", pageBreakAfter: "always" }}>
      {showApproveButton && (
        <div style={{ padding: "2rem 0rem", textAlign: "left" }}>
          <AddButton label="Approve" variant="edit"
          onClick={async() => {
              await observationSheetApprove(params?.id);
            }}
          />
        </div>
      )}

      <HeaderRowDetailsTable datasheetDetails={datasheetDetails} />

      <TestDetailsTable datasheetDetails={datasheetDetails} />

      <div className="text-sm mt-3">
        <b>DISCIPLINE : </b>
        {DisciplineOptions.find(
          (key) => key.id == datasheetDetails?.inward_disciplineId
        )?.label || ""}
      </div>

      {/* render dynamic tables */}
      <div>
        <RenderStaticTables
          tableDisplayStatus={datasheetDetails?.tableDisplayStatus}
          configuration={datasheetDetails?.observationSheet_configuration || {}}
          certificateId={datasheetDetails?.certificateId || datasheetDetails?.certificate_id}
          tableDivide={datasheetDetails?.tableDivide}
          staticCertificateReadings={datasheetDetails?.readingRows}
          staticTables={datasheetDetails?.staticTables}
        />
      </div>

      {/* note section */}
      {datasheetDetails?.observationSheet_configuration?.remark && (
        <div className="py-4 px-1 border-gray-400 text-sm">
          <p className="font-bold mb-1">Note:</p>
          <pre style={{
            fontFamily: " Calibri, sans-serif",
            fontSize: "1rem",
            marginBottom: "0px",
            whiteSpace: "pre-wrap",
          }}>
            <p>{datasheetDetails.observationSheet_configuration.remark}</p>
          </pre>
        </div>
      )}

      <DatasheetFooter datasheetDetails={datasheetDetails} />
    </div>
  );
};

const ViewDatasheet = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const [letterHead, setLetterHead] = React.useState(true);
  const [draft, setDraft] = React.useState(false);  
  const [electronicSign, setElectronicSign] = React.useState(true);
  const [loading, setLoading] = useState(false);

  const [datasheetDetails, setDatasheetDetails] = useState([]);

  useEffect(() => {
    const fetchData = async (params) => {
      const data = await fetchObservationSheetPdf(params);
      setDatasheetDetails(Array.isArray(data) ? data : [data]);
    };
    fetchData(params);
  }, [params]);

  useEffect(() => {
    if (datasheetDetails.length === 1) {
      const sheet = datasheetDetails[0];
      const hasAuthorized = !!sheet?.certificate_authorizedBy;
      const hasReadings = sheet?.observationSheet_totalReadings > 0;

      if (hasAuthorized && hasReadings) {
        setLetterHead(true);
        setDraft(false);
      } else {
        setDraft(true);
        setLetterHead(false);
      }
    }
  }, [datasheetDetails]);

  return (
    <div>
      {(permissions.pdfDownload || permissions.allAccess) && (
        <div
          className="mb-5"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            justifyContent: "flex-end",
          }}
        >
          {/* <div style={{ flex: "1 1 250px", maxWidth: "300px" }}>
            <Autocomplete
              size="small"
              id="quotation_view_letterhead"
              options={[
                { id: 1, label: "With Letter Head" },
                { id: 2, label: "Without Letter Head" },
              ]}
              renderInput={(params) => (
                <TextField {...params} label="Letter Head" />
              )}
              onInputChange={(event, newInputValue) => {
                if (
                  newInputValue === "With Letter Head" ||
                  newInputValue === ""
                ) {
                  setLetterHead(true);
                } else if (newInputValue === "Without Letter Head") {
                  setLetterHead(false);
                }
              }}
            />
          </div> */}

          {/* <div style={{ flex: "1 1 250px", maxWidth: "300px" }}>
            <Autocomplete
              size="small"
              id="quotation_view__electronicsign"
              options={[
                { id: 1, label: "With Electronically Signed" },
                { id: 2, label: "Without Electronically Signed" },
              ]}
              renderInput={(params) => (
                <TextField {...params} label="Electronically Signed" />
              )}
              onInputChange={(event, newInputValue) => {
                if (
                  newInputValue === "With Electronically Signed" ||
                  newInputValue === ""
                ) {
                  setElectronicSign(true);
                } else if (newInputValue === "Without Electronically Signed") {
                  setElectronicSign(false);
                }
              }}
            />
          </div> */}

            <AddButton
              label={letterHead ? "Download PDF" : "Download Draft"}
              id="quotation_view_generatepdf"
              onClick={() =>
                generateDatasheetPDF({
                  letterHead,
                  draft,
                  electronicSign,
                  datasheetDetails,
                  setLoading,
                })
              }
            />
        </div>
      )}

      {/* Map through all datasheets */}
      {datasheetDetails?.map((datasheetDetails, index) => (
        <SingleDatasheet
          key={datasheetDetails?.id || index}
          datasheetDetails={datasheetDetails}
          showApproveButton={
            !datasheetDetails?.observationSheet_approvedBy && 
            datasheetDetails?.observationSheet_testedBy && 
            props.rolesInfo?.currentRole?.id == 4
          }
          rolesInfo={props.rolesInfo}
          params={params}
        />
      ))}

      <LoaderModal loading={loading} />

    </div>
  );
};

export default ViewDatasheet;
